// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoadingSpinner from "./LoadingSpinner";

export function ProtectedRoute({ children, requiredRole = null }) {
  const { currentUser, hasPermission, loading } = useAuth();
  const requiredRoles = requiredRole
    ? Array.isArray(requiredRole)
      ? requiredRole
      : [requiredRole]
    : [];

  if (loading) {
    return <LoadingSpinner fullScreen message="Checking authentication..." />;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles.length > 0 && !requiredRoles.some((role) => hasPermission(role))) {
    return (
      <div
        style={{
          padding: "60px 30px",
          textAlign: "center",
          color: "var(--text-muted)",
        }}
      >
        <h2>Access Denied</h2>
        <p>You don&apos;t have permission to access this page.</p>
      </div>
    );
  }

  return children;
}
